import React from 'react'
import { cva, VariantProps } from 'class-variance-authority'
import { cn, formatPrice } from '@/lib/utils'

import { Badge, badgeVariants } from '@/components/ui'

const priceBadgeVariants = cva('flex items-center gap-2', {
  variants: {
    size: {
      default: 'text-sm',
      md: 'text-[11px]',
      lg: 'text-base',
    },
  },
  defaultVariants: {
    size: 'default',
  },
})

interface PriceBadgeProps
  extends React.ComponentPropsWithoutRef<'div'>,
    VariantProps<typeof priceBadgeVariants> {
  price: number
  badge?: VariantProps<typeof badgeVariants> &
    React.ComponentPropsWithoutRef<'div'>
}

export const PriceBadge = ({
  price,
  badge,
  size,
  className,
}: PriceBadgeProps) => {
  const {
    children: badgeChildren,
    className: badgeClassName,
    ...restBadge
  } = badge ?? {}
  return (
    <div className={cn(priceBadgeVariants({ size, className }))}>
      <Badge
        className={cn('w-[28px]', badgeClassName)}
        size={size}
        variant="green"
        {...restBadge}
      >
        {badgeChildren ?? 'RS'}
      </Badge>
      <span className={cn('font-mono font-semibold')}>
        {formatPrice(price, 2, false)}
      </span>
    </div>
  )
}
